import { MenuGroup, type MenuGroupProps } from '@chakra-ui/react';

export type UiMenuGroupProps = MenuGroupProps;

export const UiMenuGroup = MenuGroup;
